import { useLang } from '@/i18n';
import EfCardsA from '@elem/ui/ef-cards-a';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListA');
    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722951930671/Frame%201000008618.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1722952293718/Frame%201000008618%20(1).png',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722951969190/Frame%201000008619.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1722952321315/Frame%201000008619%20(1).png',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722952236895/Frame%201000008620.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1722952321315/Frame%201000008619%20(1).png',
            title: t('c_title'),
            desc: t.rich('c_desc', {
                sup: (tx: string) => <sup>{tx}</sup>,
            }),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection label={t('label')} title={t('title')} />
            <EfCardsA list={listA} />
            {/* <EfSpec /> */}
        </div>
    );
}
